import { PagePredictionProperties, PageTypes } from '@shared/types';
export function isPageInspectionCertificate(page) {
    return page.predictions[PagePredictionProperties.type] === PageTypes.certificate;
}
